export default "__VITE_ASSET__0314cdf8__"